import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// Copied into the finance module so it stays self-contained (mirrors the vertical apps' InfoTip).
let seq = 0;
export default function InfoTip({ text, children, placement = 'top' }) {
  if (!text) return children || null;
  // eslint-disable-next-line no-plusplus
  const id = `fin-tip-${++seq}`;
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip id={id}>{text}</Tooltip>}>
      {children
        ? <span style={{ cursor: 'help' }} tabIndex={0}>{children}</span>
        : (
          <span
            className="text-muted ms-1"
            style={{ cursor: 'help', fontSize: '0.85em' }}
            tabIndex={0}
            role="img"
            aria-label={text}
          >
            ⓘ
          </span>
        )}
    </OverlayTrigger>
  );
}
